// Build-time host classification. The self-serve signup host (app.<root>) and the
// platform-admin host (admin.<root>) are deliberately SERVICE-WORKER-FREE: a controlling
// SW there intercepts the auth confirm POST → cross-host 302 and eats the establish
// handoff. This is decided purely by the HOSTNAME (build-time VITE_ROOT_DOMAIN), NEVER by
// /api/me — so a failed/slow /api/me can never flip a tenant-less host into "portal" and
// register an SW there (the exact regression Fable flagged). A tenant custom domain
// (e.g. support.acme.com) is NOT tenant-less → a normal portal that gets the SW.
const ROOT_DOMAIN = import.meta.env.VITE_ROOT_DOMAIN || 'localhost';

export function isTenantlessHost() {
  const h = window.location.hostname;
  return h === `app.${ROOT_DOMAIN}` || h === `admin.${ROOT_DOMAIN}` || h === `sandbox.${ROOT_DOMAIN}`;
}
